<template>
  <BaseModal :title="'Recording'" @close="closeModal">
    <template #modalContent>
      <div class="modal-content-wrapper">
        <div class="modal-content">
          <div class="modal-heading">
            <h3>Delete recording</h3>
          </div>
          <div class="flex flex-col mt-8">
            <p class="collect-em-label">
              //Do you really want to delete this recording?
            </p>
            <span>deleteRecording()</span>
          </div>
          <p v-if="errorText" class="delete-error">{{ errorText }}</p>
          <vs-button class="mt-8" type="border" v-if="isLoading"
            >>>deleting...</vs-button
          >
          <vs-button
            class="mt-8"
            type="border"
            v-else
            @click="handleDeleteRecording"
            :disabled="nameError"
            >>>delete</vs-button
          >
        </div>
        <div class="cast-modal-bottom">
          <p>>> Delete recording > <span></span></p>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { refreshAccount } from '@/http/requests/account';
import api from '../../../../../http/api/api';
import BaseModal from '@/components/common/BaseModal.vue';
import constants from '@/../constant.js';

export default {
  name: 'DeleteModal',
  props: ['closeModal', 'recording', 'getRecordings'],
  data() {
    return {
      isLoading: false,
      nameError: false,
      errorText: '',
      recordingName: this.recording.url.Name,
    };
  },
  components: {
    BaseModal,
  },
  methods: {
    async handleDeleteRecording() {
      this.isLoading = true;
      const options = {
        method: 'DELETE',
        url: `${constants.apiRoomUrl}/api/delete/user/recording/`,
        data: {
          public_meeting_id: this.recording.url.pub_id,
          recording_id: this.recording.url['Record ID'],
        },
      };
      try {
        const res = await api.request(options);

        // the endpoint answers 200 even when it refuses, so read what it said
        const body = (res && res.data) || {};
        if (body.status === false) {
          this.errorText =
            body.message || 'That recording could not be deleted.';
          this.isLoading = false;
          return;
        }

        try {
          await this.$store.dispatch(
            'room/deleteRecording',
            this.recording.url['Record ID']
          );
        } catch (e) {
          // the list refresh below still puts the page right
        }
        refreshAccount();
        this.isLoading = false;
        this.closeModal();
        if (typeof this.getRecordings === 'function') this.getRecordings();
        return;
      } catch (error) {
        this.isLoading = false;
        const status = error && error.response && error.response.status;
        this.errorText =
          status === 401
            ? 'Your session has expired. Sign in again and retry.'
            : 'That recording could not be deleted. Try again in a moment.';
      }
    },
  },
};
</script>

<style scoped>
.delete-error {
  color: #ef4444;
  margin-top: 1rem;
  font-size: 13px;
}
.collect-em-label {
  color: #5b96eb !important;
}
</style>
